<h1 class="fw-bold fs-2 text-center mb-4">Solicita tu préstamo</h1>
<p class="px-2">Para solicitar tu préstamo ten en cuenta que debes cumplir con los siguientes requisitos</p>
<div class="card mb-4">
  <div class="card-body">
    <ul>
      <li><img src="/assets/image/icons/heart.png" alt="">Residir en España y tener DNI o NIE en vigor</li>
      <li><img src="/assets/image/icons/calendar.png" alt="">Ser mayor de edad</li>
      <li><img src="/assets/image/icons/bank.png" alt="">Ser titular de una cuenta bancaria española</li>
      <li><img src="/assets/image/icons/id.png" alt="">Identifícate con tu banco online</li>
    </ul>
    <div style="padding-top: 10px;">
      <strong>IMPORTANTE:</strong> ten en cuenta que una vez aprobada tu solicitud, la acreditación de los fondos en tu cuenta bancaria demorará entre 24h y 48hs.
    </div>
  </div>
</div>



<app-button (clicked)="goToOnBoarding()">
  Empezar
</app-button>
